import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VuePageTransition from "vue-page-transition";
import VueToastify from "vue-toastify";
import * as firebase from "firebase/app";
import "firebase/auth";
import vSelect from "vue-select";
import VueGoodTablePlugin from 'vue-good-table';
import VModal from 'vue-js-modal/dist/index.nocss.js'
import 'vue-js-modal/dist/styles.css'
import VueSocialSharing from 'vue-social-sharing'
import VueClipboard from 'vue-clipboard2'

Vue.use(VuePageTransition);
Vue.use(VModal)
Vue.use(VueGoodTablePlugin);
Vue.use(VueSocialSharing);
Vue.use(VueClipboard);

Vue.component("v-select", vSelect);

import("@/assets/styles/index.scss");
import "vue-select/dist/vue-select.css";
import 'vue-good-table/dist/vue-good-table.css'

Vue.config.productionTip = false;

//Firebase Spyows Configuration copied from the Firebase console.
const firebaseConfig = {
  apiKey: "AIzaSyDmJjZPGERhSPDmOcmZaD2QcUh0ahlqYLQ",
  authDomain: "spyows.firebaseapp.com",
  databaseURL: "https://spyows.firebaseio.com",
  projectId: "spyows",
  storageBucket: "spyows.appspot.com",
  messagingSenderId: "634206382911",
  appId: "1:634206382911:web:115e0f2a92f6cc542fc18a",
  measurementId: "G-5Z3P667BWX"
};

/**
 *Initializes the Firebase with the Configuration,
 * so the firebase products can be used throughout the project.
 * */
firebase.initializeApp(firebaseConfig);

//Firebase libraries
const auth = firebase.auth();
//Adding Toastify library.
Vue.use(VueToastify);

var app;
auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
});
